import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Thin semantic wrapper for a run of `<app-disclosure>` items (e.g. an FAQ
 * list). Renders a plain `<div>` rather than `role="list"` — `<details>`
 * elements are each their own interactive widget, not list items, so a list
 * role would need `role="listitem"` children it can't correctly have.
 */
@Component({
  selector: 'app-disclosure-group',
  imports: [],
  templateUrl: './disclosure-group.component.html',
  styleUrl: './disclosure-group.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DisclosureGroupComponent {
  protected readonly _ = '';
}
